// import React from 'react';
// import { useNavigate } from 'react-router-dom';
// import logo from '../Components/assets/MOW_logo3.png';
// import logoImage from '../Components/assets/MSignin.png';

// const ReferralLoginPage = () => {
//   const navigate = useNavigate(); // Initialize the navigate function

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     // Perform validation or API call here if needed
//     navigate('/'); // Navigate to the login page
//   };

//   return (
//     <div className="flex items-center justify-center bg-gray-50">
//       <div className="w-full rounded-lg p-6">
//         {/* Logo Section */}
//         <div className="flex justify-center mb-4">
//           <img
//             src={logo}
//             alt="logo"
//             className="w-full max-w-xs"
//           />
//         </div>

//         {/* Image Section */}
//         <div className="flex justify-center mb-4">
//           <img
//             src={logoImage}
//             alt="Illustration"
//             className="w-full max-w-xs h-64"
//           />
//         </div>

//         {/* Form Section */}
//         <form className="space-y-4 mt-14">
//           <div>
//             <label
//               htmlFor="name"
//               className="block text-sm font-medium text-gray-700"
//             >
//               Enter Your Name
//             </label>
//             <input
//               type="text"
//               id="name"
//               placeholder="Ranjita"
//               className="w-full mt-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF9630] focus:border-transparent"
//             />
//           </div>
//           <div>
//             <label
//               htmlFor="referral"
//               className="block text-sm font-medium text-gray-700"
//             >
//               Enter The Referral Code <span className="text-gray-400">(optional)</span>
//             </label>
//             <input
//               type="text"
//               id="referral"
//               placeholder="000000"
//               className="w-full mt-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF9630] focus:border-transparent"
//             />
//           </div>
//           <button
//             type="submit"
//             className="w-full bg-[#FF9630] hover:bg-[#FF9630] text-white py-2 rounded-lg font-medium"
//           >
//             Login
//           </button>
//         </form>

//         {/* Back to Login Link */}
//         <p className="text-center text-sm text-blue-500 mt-5 cursor-pointer">
//           Back to login
//         </p>
//       </div>
//     </div>
//   );
// };

// export default ReferralLoginPage;


// import React from 'react';
// import { useNavigate } from 'react-router-dom';
// import logo from '../Components/assets/MOW_logo3.png';
// import logoImage from '../Components/assets/log.gif';

// const ReferralLoginPage = () => {
//   const navigate = useNavigate(); // Initialize the navigate function

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     navigate('/'); // Navigate to the login page
//   };

//   const handleBackToLogin = () => {
//     navigate('/login-signup'); // Replace '/login' with the path to your login page
//   };

//   return (
//     <div className="flex items-center justify-center bg-gray-50">
//       <div className="w-full rounded-lg p-6">
//         {/* Logo Section */}
//         <div className="flex justify-center mb-4">
//           <img
//             src={logo}
//             alt="logo"
//             className="w-full max-w-xs"
//           />
//         </div>

//         {/* Image Section */}
//         <div className="flex justify-center mb-4">
//           <img
//             src={logoImage}
//             alt="Illustration"
//             className="w-full max-w-xs h-64"
//           />
//         </div>

//         {/* Form Section */}
//         <form className="space-y-4 mt-14" onSubmit={handleSubmit}>
//           <div>
//             <label
//               htmlFor="name"
//               className="block text-sm font-medium text-gray-700"
//             >
//               Enter Your Name
//             </label>
//             <input
//               type="text"
//               id="name"
//               placeholder="Ranjita"
//               className="w-full mt-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF9630] focus:border-transparent"
//             />
//           </div>
//           <div>
//             <label
//               htmlFor="referral"
//               className="block text-sm font-medium text-gray-700"
//             >
//               Enter The Referral Code <span className="text-gray-400">(optional)</span>
//             </label>
//             <input
//               type="text"
//               id="referral"
//               placeholder="000000"
//               className="w-full mt-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF9630] focus:border-transparent"
//             />
//           </div>
//           <button
//             type="submit"
//             className="w-full bg-[#FF9630] hover:bg-[#FF9630] text-white py-2 rounded-lg font-medium"
//           >
//             Login
//           </button>
//         </form>

//         {/* Back to Login Link */}
//         <p
//           className="text-center text-sm text-blue-500 mt-5 cursor-pointer"
//           onClick={handleBackToLogin}
//         >
//           Back to login
//         </p>
//       </div>
//     </div>
//   );
// };

// export default ReferralLoginPage;

import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setUsername } from '../../../Redux/Slice/LoginSlice';
import logo from '../../assets/MOW_logo3.png';
import logoImage from '../../assets/log.gif';

const ReferralLoginPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    referral: '',
  });

  const dispatch = useDispatch();
  const navigate = useNavigate(); // Initialize the navigate function

  const handleSubmit = (e) => {
    e.preventDefault();

    // Dispatch the username to the Redux store
    dispatch(setUsername(formData.name));

    // Navigate to the home page after submission
    navigate('/');
  };

  const handleBackToLogin = () => {
    navigate('/login-signup'); // Replace with the correct path to your login page
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div className="flex items-center justify-center bg-gray-50">
      <div className="w-full rounded-lg p-6">
        {/* Logo Section */}
        <div className="flex justify-center mb-4">
          <img src={logo} alt="logo" className="w-full max-w-xs" />
        </div>

        {/* Image Section */}
        <div className="flex justify-center mb-4">
          <img src={logoImage} alt="Illustration" className="w-full max-w-xs h-64" />
        </div>

        {/* Form Section */}
        <form className="space-y-4 mt-14" onSubmit={handleSubmit}>
          <div>
            <label htmlFor="name" className="block text-sm font-medium text-gray-700">
              Enter Your Name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Ranjita"
              className="w-full mt-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF9630] focus:border-transparent"
            />
          </div>
          <div>
            <label htmlFor="referral" className="block text-sm font-medium text-gray-700">
              Enter The Referral Code <span className="text-gray-400">(optional)</span>
            </label>
            <input
              type="text"
              id="referral"
              name="referral"
              value={formData.referral}
              onChange={handleChange}
              placeholder="000000"
              className="w-full mt-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF9630] focus:border-transparent"
            />
          </div>
          <button type="submit" className="w-full bg-[#FF9630] hover:bg-[#FF9630] text-white py-2 rounded-lg font-medium">
            Login
          </button>
        </form>

        {/* Back to Login Link */}
        <p className="text-center text-sm text-blue-500 mt-5 cursor-pointer" onClick={handleBackToLogin}>
          Back to login
        </p>
      </div>
    </div>
  );
};

export default ReferralLoginPage;
